module.exports = __webpack_public_path__ + "img/icon_fb.6f766fae.svg";